import React, { useEffect, useRef, useState } from 'react';
import MainLayout from 'components/MainLayout';
import { Card, Col, DatePicker, Input, Row, Typography } from 'antd';
import styled from 'styled-components';
import CustomButton from 'components/common/CustomButton';
import AuditTrailTable from 'components/tables/AuditTrailTable';
import { auditTrailReport } from 'api/queries/Report';
import { useQuery } from 'react-query';
import { useDispatch } from 'react-redux';
import PageLoader from 'components/common/PageLoader';
import AppData from 'AppData';

const AuditTrail = () => {
  const { Text } = Typography;
  const { RangePicker } = DatePicker;
  const searchRef = useRef();
  const [searchVal, setSearchVal] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [startDate, setStartDate] = useState('');
  const [toggleExport, setToggleExport] = useState(false);
  const [endDate, setEndDate] = useState('');
  const [pageSize, setPageSize] = useState(10);
  const [value, setValue] = React.useState();
  const { isLoading, data: audittrailResult, refetch: refetchReport } = useQuery(
    [
      'auditTrailReport',
      searchVal,
      0,
      0,
      toggleExport ? 1 : currentPage,
      toggleExport ? AppData.infinitePage : pageSize,
      startDate,
      endDate,
      toggleExport
    ],
    auditTrailReport
  );

  const onSearch = value => setSearchVal(value);

  const onDateChange = (date, dateString) => {
    setValue(dateString);
    // setStartDate(dateString[0]);
    // setEndDate(dateString[1]);
    // console.log(date, dateString);
  };

  useEffect(() => {
    if (audittrailResult && toggleExport && !isLoading) {
      base64Download(audittrailResult?.file);
      setToggleExport(false);
    }
  }, [audittrailResult, isLoading, toggleExport]);

  const base64Download = (base64Url, fileName = 'AuditTrail.xlsx') => {
    const a = document.createElement('a');
    document.body.appendChild(a);
    a.href = `data:application/octet-stream;base64,${base64Url}`;
    a.download = fileName;
    a.click();
  };
  return (
    <MainLayout isAdmin sidebar padded selectedKey="auditTrail">
      <Card>
        <HeaderRow gutter={[16, 24]}>
          <Col sm={{ span: 16 }} md={{ span: 6 }} xs={{ span: 24 }}>
            <Title level={2}>Audit Trail</Title>
            <Text>Discover your overall course analytics</Text>
          </Col>
          <CenterCol sm={{ span: 24 }} md={{ span: 14 }} xs={{ span: 24 }}>
            <Search
              placeholder="Search Name, Action"
              onSearch={onSearch}
              ref={searchRef}
              size="large"
            />
            <RangePicker onChange={onDateChange} />
          </CenterCol>
          <ExportCol sm={{ span: 24 }} md={{ span: 4 }} xs={{ span: 24 }}>
            <CustomButton
              bgColor="#4d4d53"
              color="#fff"
              size="large"
              onClick={() => {
                setSearchVal(searchRef?.current?.state?.value);
                setStartDate(value[0]);
                setEndDate(value[1]);
              }}>
              Search
            </CustomButton>
            <CustomButton
              bgColor="#4d4d53"
              color="#fff"
              size="large"
              onClick={() => {
                setToggleExport(true);
              }}>
              Export
            </CustomButton>
          </ExportCol>
        </HeaderRow>
        {audittrailResult && (
          <AuditTrailTable
            audittrailResult={audittrailResult}
            currentPage={currentPage}
            pageSize={pageSize}
            setCurrentPage={setCurrentPage}
            setPageSize={setPageSize}
            toggleExport={toggleExport}
          />
        )}
      </Card>
      <PageLoader fullWidth={isLoading} fullHeight={isLoading} isLoading={isLoading} />
    </MainLayout>
  );
};

const Title = styled(Typography.Title)`
  margin-bottom: 0px !important;
`;

const CenterCol = styled(Col)`
  display: flex;
  margin: auto;
`;

const ExportCol = styled(Col)`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`;

const Search = styled(Input.Search)`
  width: 50%;
  margin-right: 10px;
`;

const HeaderRow = styled(Row)`
  margin-bottom: 20px;
`;

export default AuditTrail;
